import { Backdrop, Fade, IconButton, Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { InfoAwesomeIcon } from 'app/shared/icons';
import { Markup } from 'interweave';
import React from 'react';
import { ButtonLounge } from '../button/button-louge';
// import '../modal-style.scss';

export interface IModalInfoProps {
    className?: string;
    modal: boolean;
    message: string[];
    txtBackButton?: string;
    txtContactUsButton?: string;
    setModal(data: boolean): void;
    hideClose?: boolean;
    contactUsButtonAction?(): void;
    closeAction?(): void;
    backAction?(): void;
}
const ModalGenerateBpError = (props: IModalInfoProps) => {
    const {
        modal,
        message,
        setModal,
        className,
        txtBackButton,
        txtContactUsButton,
        hideClose,
        contactUsButtonAction,
        closeAction,
        backAction
    } = props;

    const handleBackClick = () => {
        if (backAction) {
            backAction();
        }
        setModal(false);
    }

    const handleContactUsClick = () => {
        if (contactUsButtonAction) {
            contactUsButtonAction();
        }
        setModal(false);
    }

    const handleCloseClick = () => {
        if (closeAction) {
            closeAction();
        }
        setModal(false);
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={"modal-container"}
            open={modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={modal}>
                <div className="paper-info">
                    {!hideClose && <IconButton className="btn-close" onClick={handleCloseClick}>
                        <CloseIcon htmlColor="var(--primary-text)" />
                    </IconButton>
                    }
                    <InfoAwesomeIcon />
                    <div className={"paper-info-text " + (className ? className : "")}>
                        {
                            message.map((msg, index) => {
                                return (
                                    <div key={index}>
                                        <Markup noWrap content={msg} />
                                    </div>
                                );
                            })}
                    </div>
                    <br />
                    {(txtBackButton || txtContactUsButton) &&
                        <div className="row justify-content-center">
                            {txtBackButton &&
                                <div className="col-6">
                                    <ButtonLounge title={txtBackButton} action={handleBackClick} style={'1'} />
                                </div>
                            }
                            {txtContactUsButton &&
                                <div className="col-6">
                                    <ButtonLounge title={txtContactUsButton} action={handleContactUsClick} style={'1'} />
                                </div>
                            }
                        </div>
                    }
                </div>
            </Fade>
        </Modal>
    );
}


export default ModalGenerateBpError;
